"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const v2_1 = require("smartrips-skin/lib/v2");
const getColors = ({ fill, variant, }) => {
    if (fill === "outlined") {
        switch (variant) {
            case "blue":
                return `
          background-color: ${v2_1.theme.colors.white};
          border-color: ${v2_1.theme.colors.blue[500]};
          color: ${v2_1.theme.colors.blue[500]};
          &:hover {
            border-color: ${v2_1.theme.colors.blue[700]};
            color: ${v2_1.theme.colors.blue[700]};
          }
          &:disabled {
            border-color: ${v2_1.theme.colors.blue[300]};
            color: ${v2_1.theme.colors.blue[300]};
            cursor: default;
            &:hover {
            }
          }
        `;
            case "default":
                return `
          background-color: ${v2_1.theme.colors.white};
          border-color: ${v2_1.theme.colors.gray[500]};
          color: ${v2_1.theme.colors.gray[500]};
          &:hover {
            border-color: ${v2_1.theme.colors.gray[700]};
            color: ${v2_1.theme.colors.gray[700]};
          }
          &:disabled {
            border-color: ${v2_1.theme.colors.gray[300]};
            color: ${v2_1.theme.colors.gray[300]};
            cursor: default;
            &:hover {
            }
          }
        `;
            case "green":
                return `
          background-color: ${v2_1.theme.colors.white};
          border-color: ${v2_1.theme.colors.green[500]};
          color: ${v2_1.theme.colors.green[500]};
          &:hover {
            border-color: ${v2_1.theme.colors.green[700]};
            color: ${v2_1.theme.colors.green[700]};
          }
          &:disabled {
            border-color: ${v2_1.theme.colors.green[300]};
            color: ${v2_1.theme.colors.green[300]};
            cursor: default;
            &:hover {
            }
          }
        `;
            case "pink":
                return `
          background-color: ${v2_1.theme.colors.white};
          border-color: ${v2_1.theme.colors.pink[500]};
          color: ${v2_1.theme.colors.pink[500]};
          &:hover {
            border-color: ${v2_1.theme.colors.pink[700]};
            color: ${v2_1.theme.colors.pink[700]};
          }
          &:disabled {
            border-color: ${v2_1.theme.colors.pink[300]};
            color: ${v2_1.theme.colors.pink[300]};
            cursor: default;
            &:hover {
            }
          }
        `;
            default:
                return `
          background-color: ${v2_1.theme.colors.white};
          border-color: ${v2_1.theme.colors.gray[500]};
          color: ${v2_1.theme.colors.gray[500]};
          &:hover {
            border-color: ${v2_1.theme.colors.gray[700]};
            color: ${v2_1.theme.colors.gray[700]};
          }
          &:disabled {
            border-color: ${v2_1.theme.colors.gray[300]};
            color: ${v2_1.theme.colors.gray[300]};
            cursor: default;
            &:hover {
            }
          }
        `;
        }
    }
    switch (variant) {
        case "blue":
            return `
        background-color: ${v2_1.theme.colors.blue[500]};
        border-color: ${v2_1.theme.colors.blue[500]};
        color: ${v2_1.theme.colors.white};
        &:hover {
          background-color: ${v2_1.theme.colors.blue[700]};
          border-color: ${v2_1.theme.colors.blue[700]};
        }
        &:disabled {
          background-color: ${v2_1.theme.colors.blue[300]};
          border-color: ${v2_1.theme.colors.blue[300]};
          cursor: default;
          &:hover {
          }
        }
      `;
        case "default":
            return `
        background-color: ${v2_1.theme.colors.gray[500]};
        border-color: ${v2_1.theme.colors.gray[500]};
        color: ${v2_1.theme.colors.white};
        &:hover {
          background-color: ${v2_1.theme.colors.gray[700]};
          border-color: ${v2_1.theme.colors.gray[700]};
        }
        &:disabled {
          background-color: ${v2_1.theme.colors.gray[300]};
          border-color: ${v2_1.theme.colors.gray[300]};
          cursor: default;
          &:hover {
          }
        }
      `;
        case "green":
            return `
        background-color: ${v2_1.theme.colors.green[500]};
        border-color: ${v2_1.theme.colors.green[500]};
        color: ${v2_1.theme.colors.white};
        &:hover {
          background-color: ${v2_1.theme.colors.green[700]};
          border-color: ${v2_1.theme.colors.green[700]};
        }
        &:disabled {
          background-color: ${v2_1.theme.colors.green[300]};
          border-color: ${v2_1.theme.colors.green[300]};
          cursor: default;
          &:hover {
          }
        }
      `;
        case "pink":
            return `
        background-color: ${v2_1.theme.colors.pink[500]};
        border-color: ${v2_1.theme.colors.pink[500]};
        color: ${v2_1.theme.colors.white};
        &:hover {
          background-color: ${v2_1.theme.colors.pink[700]};
          border-color: ${v2_1.theme.colors.pink[700]};
        }
        &:disabled {
          background-color: ${v2_1.theme.colors.pink[300]};
          border-color: ${v2_1.theme.colors.pink[300]};
          cursor: default;
          &:hover {
          }
        }
      `;
        default:
            return `
        background-color: ${v2_1.theme.colors.gray[500]};
        border-color: ${v2_1.theme.colors.gray[500]};
        color: ${v2_1.theme.colors.white};
        &:hover {
          background-color: ${v2_1.theme.colors.gray[700]};
          border-color: ${v2_1.theme.colors.gray[700]};
        }
        &:disabled {
          background-color: ${v2_1.theme.colors.gray[300]};
          border-color: ${v2_1.theme.colors.gray[300]};
          cursor: default;
          &:hover {
          }
        }
      `;
    }
};
const getShape = ({ shape }) => {
    switch (shape) {
        case "icon":
            return `
        align-items: center;
        aspect-ratio: 1;
        height: 40px;
        justify-content: center;
        padding: 0;
        width: 40px;
      `;
        case "default":
            return `
        align-items: center;
        gap: 12px;
    `;
        default:
            return ``;
    }
};
exports.styles = {
    root: styled_1.default.button `
    border: 1px solid;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 500;
    padding: 14px 24px;
    transition: all 0.15s ease-in-out;
    ${({ fill, variant }) => getColors({ fill, variant })}
    ${({ shape }) => getShape({ shape })}
  `,
};
